export default class CommissionStat {
  $onInit() {
    this.symbol = ['week', 'day'].includes(this.frequency) ? '' : '%';
  }
}
